export class ComponentWatcher {
    constructor(callback) {
        this.callback = callback;
        this.isTicking = false;
        this.observer = new MutationObserver(this.handler.bind(this));
        this.observer.observe(document, {attributes: false, childList: true, characterData: false, subtree: true})
    }

    // This handler throttles the calls to `handleMutation` which actually does the work.
    handler() {
        if (!this.isTicking) {
            window.requestAnimationFrame(() => {
                this.handleMutation();
                this.isTicking = false;
            });
            this.isTicking = true;
        }
    };

    handleMutation() {
        this.callback();
    }
}